import { render, staticRenderFns } from "./alert.vue?vue&type=template&id=7a995990&scoped=true"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"
import style0 from "./alert.vue?vue&type=style&index=0&id=7a995990&prod&lang=scss"
import style1 from "./alert.vue?vue&type=style&index=1&id=7a995990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a995990",
  null
  
)

export default component.exports